import { FunctionComponent, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Link,
  CircularProgress,
} from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import { get, isEmpty, isNull, isNil } from 'lodash';
import useCollapse from 'hooks/useCollapse';
import { history } from 'store';
import { Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import fr from 'timeago.js/lib/lang/fr';
import Notification from 'components/SahamIcons/Notification';
import InboxesIcon from 'components/SahamIcons/InboxesIcon';
import InboxesDrawer from 'containers/AppContainer/AppBar/InboxesDrawer';
import Profil from 'components/SahamIcons/Profil';
import LawyerProfil from 'components/SahamIcons/ LawyerProfil';
import messages from 'containers/AppContainer/messages';
import { translate } from 'containers/services/translate';
import AlertNotification from 'containers/AppContainer/Notifications/AlertNotification';
import {
  UserInfo,
  Listings,
  INotification,
} from 'containers/AppContainer/typings';
import {
  isOpeningManager,
  resolveCount,
  utils,
  countNotifications,
  isExpertMechanic,
  extractOpeningNotificationType,
  renderPath,
  renderLegalProceedingTab,
  renderGlobalTab,
  renderInstanceTab,
  isRejectionTitle,
  renderExpertiseTab,
  isInboxeTitle,
  renderTransactionTab,
  renderRegulationTab,
  renderLawyerGlobalTab,
  renderLawyerLegalProceedingTab,
} from 'containers/AppContainer/utils';
import userPrivileges, {
  userHasPrivilege,
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import SahamDrawer from 'components/SahamDrawer';
import MedicalExpertProfil from 'components/SahamIcons/ExpertProfil';
import AccountingExpertProfil from 'components/SahamIcons/AccountingExpertIcon';
import ExpertMechanicProfil from 'components/SahamIcons/ExpertMechanicIcon';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import Bin from 'containers/AppContainer/Notifications/Bin';
import NotificationEmptyBloc from 'containers/AppContainer/Notifications/EmptyBloc';
import { StyledGrid } from 'containers/AppContainer/Notifications/Bin';
import { Dialog } from 'containers/CourtManagerAssignedClaims/styled-components';
import {
  BIN_MANAGER_OPENING_MANAGER,
  BIN_MOUNITORING_COURT_MANAGER,
  PATH_MONITORING_MANAGER,
  NOTIFICATION_CLAIM_CONVERTION,
} from 'containers/AppContainer/constants';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { AppBarDiv, BinDiv } from 'containers/AppContainer/AppBar/style';
import BinsWrapper from 'containers/AppContainer/Notifications/BinsWrapper';
import {
  BIN_INVOICE_TITLE,
  CORRECTIONAL_PROCEDURE_ID,
} from 'containers/AppContainer/AppBar/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { isExpertAccounting } from 'containers/AppContainer/utils';
import { PAGES } from 'routes';
import { getAssignedManagerCode } from 'containers/CourtManagerAssignedClaims/utils';
import { LISTINGS, PROCEDURE_STATUSES } from 'containers/data-structure';
import {
  renderTitleConfirmationDialog,
  renderSubTitleConfirmationDialog,
  isLawyer,
} from 'containers/AppContainer/utils';
import { isTransactionManager } from 'helpers/utils';
import LaywerInboxesDrawer from 'containers/AppContainer/AppBar/LawyerInboxesDrawer';
import { getFeeNote } from 'containers/AppContainer/AppBar/utils';
import { ClaimRecapType } from 'typings/claimTypes';
import { useDispatch } from 'react-redux';
import { resetProvisionalClaimDetailsStore } from 'containers/ProvisionalClaimRecap/actions';
import { OPENING_STATE } from 'services/constants';
import { requestSearchClaims } from 'containers/IdentificationPage/actions';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';

export interface AppBarProps {
  intl: IntlShape;
  showStepper?: Boolean;
  userInfo: UserInfo | undefined;
  logout: any | undefined;
  location: { pathname: string };
  listings: Listings;
  lawyerNotifications: INotification[];
  managerNotifications: INotification[];
  expertNotifications: INotification[];
  requestReadLawyerNotification: Function;
  requestReadManagerNotification: Function;
  requestReadExpertNotification: Function;
  openingManagerNotificationsMixedClaim: INotification[];
  setClaimNumber: Function;
  setSelectedClaim: Function;
  setNotification: Function;
  setCurrentIndexTabManager: Function;
  setCurrentIndexTabJudiciaryProcessManager: Function;
  setCurrentInstanceTab: Function;
  setCurrentIndexGlobalTabManager: Function;
  setNotificationFeeNote: Function;
  requestReadConvertClaimNotification: Function;
  requestGetManagerNotifications: any;
  loaders: any;
  page: any;
  setPage: Function;
  requestRefreshManager: Function;
  notificationsInboxes: any;
  countNotificationsManager: any;
  countInboxesNotificationsManager: any;
  setCurrentIndexTabExpertise: Function;
  requestGetNotificationsInboxes: Function;
  successCallBackRefresh: Function;
  requestUnlockClaim: Function;
  claimRecap: ClaimRecapType;
  setLockedClaim: Function;
  resetStoreClaim: Function;
  resetSearchClaimsStore: Function;
  requestResetHistoryStore: Function;
  resetSagisInfoClaim: Function;
  setCurrentIndexTabTransaction: Function;
  setTransactionId: Function;
  setCurrentRegulationPath: Function;
  requestGetInboxesLawyerNotifications: Function;
  inboxesLawyerNotifications: any;
  countInboxesLawyerNotifications: any;
  setCurrentIndexGlobalTabLawyer: Function;
  setCurrentIndexTabJudiciaryProcessLawyer: Function;
  setCurrentIndexTabLawyer: Function;
}
const AppBarContainer: FunctionComponent<AppBarProps> = ({
  lawyerNotifications,
  managerNotifications,
  expertNotifications,
  requestReadLawyerNotification,
  requestReadManagerNotification,
  requestReadExpertNotification,
  openingManagerNotificationsMixedClaim,
  setCurrentIndexTabManager,
  setCurrentInstanceTab,
  setCurrentIndexGlobalTabManager,
  setCurrentIndexTabJudiciaryProcessManager,
  setNotificationFeeNote,
  notificationsInboxes,
  setCurrentIndexTabExpertise,
  setCurrentIndexTabTransaction,
  setTransactionId,
  setCurrentRegulationPath,
  requestGetInboxesLawyerNotifications,
  inboxesLawyerNotifications,
  countInboxesLawyerNotifications,
  setCurrentIndexGlobalTabLawyer,
  setCurrentIndexTabJudiciaryProcessLawyer,
  setCurrentIndexTabLawyer,
  ...props
}): JSX.Element => {
  const dispatch = useDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerInboxesOpen, setIsDrawerInboxesOpen] = useState(false);
  const [isDrawerLawyerInboxesOpen, setIsDrawerLaywerInboxesOpen] = useState(
    false,
  );
  const [isNotificationDialogOpen, setIsNotificationDialogOpen] = useState<
    boolean
  >(false);
  const [expandRow, setExpandRow] = useCollapse(
    get(props.listings, 'binLawyer', []),
  );
  const [expandRowInboxe, setExpandRoweInboxe] = useCollapse(
    get(props.listings, 'managerInboxes', []),
  );
  const [currentClaimId, setCurrentClaimId] = useState<number | null>(null);
  const [currentNotificationId, setCurrentNotificationId] = useState<
    number | null
  >(null);
  const [currentNotification, setCurrentNotification] = useState<{}>();
  const [
    currentExpertNotification,
    setCurrentExpertNotification,
  ] = useState<{} | null>({});
  const isClaimRejected = !isEmpty(lawyerNotifications)
    ? get(
        lawyerNotifications.find((el: any) => el.id === currentNotificationId),
        'claim.status',
      )
    : null;
  const lawyerBins = get(props.listings, 'binLawyer', []);
  const invoiceLawyerBin = lawyerBins.find(
    (el: any) => el.title === BIN_INVOICE_TITLE,
  );
  const isConsultationManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCONSULTATIONMANAGER,
  );
  const checkIsInvoiceNotification = () => {
    return !isNil(get(currentNotification, 'feeNoteId', null));
  };

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  const handleCloseNotificationDialog = () => {
    setIsNotificationDialogOpen(false);
  };
  const isManagerOpeningManager =
    userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
    userHasPrivilege(PRIVILEGES.ISMANAGER);
  const isMonitoringCourtManager = userHasPrivilege(
    PRIVILEGES.ISCOURTMONITORINGMANAGER,
  );
  const isManagerCourtMonitoringManager =
    userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
    userHasPrivilege(PRIVILEGES.ISMANAGER);
  const isPreOpeningManager = userHasPrivilege(PRIVILEGES.ISPREOPENMANAGER);
  const istransactionManager = isTransactionManager();
  const isPriorityClaimManager = userHasPrivilege(
    PRIVILEGES.ISPRIORITYCLAIMSMANAGER,
  );
  const handleResetStore = () => {
    props.resetSearchClaimsStore();
    props.resetSagisInfoClaim();
    props.resetStoreClaim();
    props.setNotification({});
    props.requestUnlockClaim({}, () => {
      props.setLockedClaim(null);
      props.requestResetHistoryStore();
    });
  };
  const checkIsProvisinalClaimNotification = () => {
    return (
      featureService.hasFeature(FEATURES.COURT_CALENDAR) &&
      featureService.hasFeature(FEATURES.LAWYER_INBOXES) &&
      !isNil(get(currentNotification, 'provisionalClaimId', null))
    );
  };
  const handleValidate = () => {
    if (utils.isManager(props)) {
      if (featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)) {
        get(currentNotification, 'type', null) !==
          NOTIFICATION_CLAIM_CONVERTION && handleResetStore();
        setCurrentIndexTabManager(
          renderLegalProceedingTab(currentNotification),
        );
        setCurrentIndexGlobalTabManager(renderGlobalTab(currentNotification));
        setCurrentInstanceTab(
          renderInstanceTab(get(currentNotification, 'judgement', {})),
        );
        setCurrentIndexTabJudiciaryProcessManager(
          get(currentNotification, 'judiciaryProcessId', null),
        );
        setCurrentIndexTabExpertise(renderExpertiseTab(currentNotification));
        setCurrentIndexTabTransaction(
          renderTransactionTab(currentNotification),
        );
        setCurrentRegulationPath(renderRegulationTab(currentNotification));
      }
      if (
        get(currentNotification, 'type', null) ===
          NOTIFICATION_CLAIM_CONVERTION &&
        featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)
      ) {
        props.setClaimNumber(get(currentNotification, 'claimNumber', ''));
        props.setSelectedClaim(0);
        props.requestReadConvertClaimNotification({
          id: get(currentNotification, 'id'),
          isRead: true,
          readBy: get(currentUserStorage.get(), 'username', ''),
        });
      } else {
        if (
          !isEmpty(get(currentNotification, 'notificationManagerMapping')) &&
          !isEmpty(
            get(currentNotification, 'notificationManagerMapping', []).filter(
              (item: any) =>
                get(item, 'userPrivilegesId') ===
                get(currentUserStorage.get().privileges, 'id'),
            ),
          ) &&
          isNull(get(currentNotification, 'claimId', null))
        ) {
          props.requestRefreshManager(props.successCallBackRefresh);
          requestReadManagerNotification({
            id: currentNotificationId,
            isTransaction: !isNil(
              get(currentNotification, 'transactionInboxeAreaId', null),
            ),
          });
        } else {
          if (isNull(get(currentNotification, 'claimId', null))) {
            toast.success(translate(messages.claimNotExist, props));
          } else {
            requestReadManagerNotification({
              id: currentNotificationId,
              isTransaction: !isNil(
                get(currentNotification, 'transactionInboxeAreaId', null),
              ),
            });
          }
        }
      }
      if (
        !isNil(
          get(currentNotification, 'timelineTransaction.transactionId', null),
        )
      ) {
        setTransactionId(
          get(currentNotification, 'timelineTransaction.transactionId', null),
        );
      }
      if (!isEmpty(get(currentNotification, 'documentImaging', null))) {
        props.setNotification(currentNotification);
      }

      if (!isNull(get(currentNotification, 'feeNoteId', null))) {
        setNotificationFeeNote(get(currentNotification, 'feeNote', {}));
      }
    } else if (utils.isExpert(props)) {
      requestReadExpertNotification(get(currentExpertNotification, 'id'));
    } else {
      if (featureService.hasFeature(FEATURES.LAWYER_INBOXES)) {
        if (get(currentNotification, 'judgementId', null)) {
          setCurrentIndexGlobalTabLawyer(
            renderLawyerGlobalTab(currentNotification),
          );
          setCurrentIndexTabJudiciaryProcessLawyer(
            get(currentNotification, 'judiciaryProcessId', null),
          );
          setCurrentIndexTabLawyer(
            renderLawyerLegalProceedingTab(currentNotification),
          );
        } else if (get(currentNotification, 'feeNoteId', null)) {
          setNotificationFeeNote(
            getFeeNote(
              currentNotificationId as number,
              inboxesLawyerNotifications,
              'feeNote',
              {},
            ),
          );
        }
        requestReadLawyerNotification(currentNotificationId);
        if (
          featureService.hasFeature(FEATURES.COURT_CALENDAR) &&
          checkIsProvisinalClaimNotification()
        ) {
          dispatch(resetProvisionalClaimDetailsStore());
        }
        if (
          featureService.hasFeature(FEATURES.OPENING_BY_USAGE) &&
          get(currentNotification, 'claim.openingState', null) ===
            OPENING_STATE.NOT_COMPLETED
        ) {
          dispatch(
            requestSearchClaims({
              claimNumber: get(currentNotification, 'claim.claimNumber'),
            }),
          );
          dispatch(requestClaimRecap(get(currentNotification, 'claimId')));
          setIsNotificationDialogOpen(false);
          setIsDrawerOpen(false);
          setIsDrawerInboxesOpen(false);
          setIsDrawerLaywerInboxesOpen(false);
          return history.push({
            pathname: PAGES.PREOPENING,
            state: {
              claimId: get(currentNotification, 'claimId'),
              isUsageOpening: true,
            },
          });
        }
      } else {
        if (
          !isNil(
            getFeeNote(
              currentNotificationId as number,
              lawyerNotifications,
              'feeNoteId',
              null,
            ),
          )
        ) {
          requestReadLawyerNotification(currentNotificationId);
          setNotificationFeeNote(
            getFeeNote(
              currentNotificationId as number,
              lawyerNotifications,
              'feeNote',
              {},
            ),
          );
        } else {
          requestReadLawyerNotification(currentNotificationId);
        }
      }
    }
    const pushTo =
      get(currentNotification, 'type', null) ===
        NOTIFICATION_CLAIM_CONVERTION &&
      featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)
        ? PAGES.CONVERT_CLAIM_MANAGER_PAGE
        : renderPath(
            props,
            isManagerOpeningManager,
            currentClaimId,
            isClaimRejected,
            currentExpertNotification,
            currentNotification,
            isPreOpeningManager,
            checkIsInvoiceNotification(),
            istransactionManager,
            checkIsProvisinalClaimNotification(),
            get(currentNotification, 'provisionalClaimId', null),
          );
    const monitoringCourtManagerUrl =
      !isEmpty(get(currentNotification, 'notificationManagerMapping')) &&
      !isEmpty(
        get(currentNotification, 'notificationManagerMapping', []).filter(
          (item: any) =>
            get(item, 'userPrivilegesId') ===
            get(currentUserStorage.get().privileges, 'id'),
        ),
      )
        ? `${PAGES.COURT_MANAGER_HOME}`
        : !isNil(get(currentNotification, 'title', null)) &&
          isRejectionTitle(get(currentNotification, 'title'))
        ? PAGES.COURT_MONITORING_MANAGER_ASSINGED_EXPERTISE
        : `${PATH_MONITORING_MANAGER}${currentClaimId}`;
    history.push(isMonitoringCourtManager ? monitoringCourtManagerUrl : pushTo);

    setIsNotificationDialogOpen(false);
    setIsDrawerOpen(false);
    setIsDrawerInboxesOpen(false);
    setIsDrawerLaywerInboxesOpen(false);
  };
  timeago.register('fr', fr);

  interface ProcedureType {
    id: number;
    title: string;
  }

  const procedures: ProcedureType[] = get(
    props.listings,
    'binJudiciaryProcess',
    [],
  );
  const filtredProcedures = procedures.filter(
    el => el.id !== CORRECTIONAL_PROCEDURE_ID,
  );
  const sortedProcedures = [
    procedures.find(el => el.id === CORRECTIONAL_PROCEDURE_ID),
    ...filtredProcedures,
  ];

  const assignedManagerCode = getAssignedManagerCode(
    get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
    get(currentUserStorage.get(), 'username', ''),
  );

  const renderIconExpert = () => {
    if (isExpertAccounting(props)) {
      return <AccountingExpertProfil />;
    } else if (isExpertMechanic(props)) {
      return <ExpertMechanicProfil />;
    } else {
      return <MedicalExpertProfil />;
    }
  };
  const handleScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (parseInt(scrollTop) + clientHeight === scrollHeight) {
      props.setPage(props.page + 1);
      props.requestGetManagerNotifications({
        page: props.page,
        assignedManagerCode: assignedManagerCode,
        isManagerOpeningManager,
        isMonitoringCourtManager,
        isManagerCourtMonitoringManager,
        isPreOpeningManager,
        isTransactionManager: istransactionManager,
        userPrivilegesId: get(currentUserStorage.get(), 'privileges.id'),
        isPriorityClaimManager,
      });
    }
  };
  const OpeningTypeNotifications = extractOpeningNotificationType(
    props.listings,
  );
  const handleClickNotificationInboxe = (el: any) => {
    if (el?.type === NOTIFICATION_CLAIM_CONVERTION) {
      setIsNotificationDialogOpen(true);
      setCurrentNotification(el);
      props.setNotification(el);
      setIsDrawerInboxesOpen(false);
    } else {
      setIsNotificationDialogOpen(true);
      setCurrentNotificationId(el.id);
      setCurrentClaimId(el.claimId);
      setCurrentNotification(el);
    }
  };

  return (
    <AppBarDiv>
      <AppBar position="fixed" color="secondary" className="appBarStyle">
        <Toolbar>
          <Typography variant="h6" className="title" />
          {featureService.hasFeature(FEATURES.LAWYER_INBOXES) && isLawyer() && (
            <Badge
              badgeContent={countInboxesLawyerNotifications}
              color="primary"
              style={{ marginRight: '10px', marginTop: '5px' }}
              max={100000000}
            >
              <IconButton
                className="btnStyle"
                color="inherit"
                data-testId={'inboxe-icon'}
                onClick={() =>
                  setIsDrawerLaywerInboxesOpen(!isDrawerLawyerInboxesOpen)
                }
              >
                <InboxesIcon width={'25px'} height={'25px'} />
              </IconButton>
            </Badge>
          )}
          {featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER) &&
            utils.isManager(props) &&
            !isConsultationManager && (
              <Badge
                badgeContent={props.countInboxesNotificationsManager}
                color="primary"
                style={{ marginRight: '10px', marginTop: '5px' }}
                max={100000000}
              >
                <IconButton
                  className="btnStyle"
                  color="inherit"
                  data-testId={'inboxe-icon'}
                  onClick={() => setIsDrawerInboxesOpen(!isDrawerInboxesOpen)}
                >
                  <InboxesIcon width={'25px'} height={'25px'} />
                </IconButton>
              </Badge>
            )}
          {!isConsultationManager && (
            <Badge
              badgeContent={countNotifications(
                props,
                managerNotifications,
                expertNotifications,
                lawyerNotifications,
                openingManagerNotificationsMixedClaim,
                isManagerOpeningManager,
                currentIntervenantStorage.get()?.sagis_code,
                isMonitoringCourtManager,
                isManagerCourtMonitoringManager,
                isOpeningManager(),
                OpeningTypeNotifications,
              )}
              color="primary"
              max={100000000}
            >
              <IconButton
                className="btnStyle"
                color="inherit"
                onClick={handleToggleDrawer}
              >
                <Notification />
              </IconButton>
            </Badge>
          )}

          <div className="divider"></div>
          <IconButton className="btnStyle" color="inherit">
            {utils.isManager(props) ? (
              <Profil />
            ) : utils.isExpert(props) ? (
              renderIconExpert()
            ) : (
              <LawyerProfil />
            )}
          </IconButton>
          <span className="profilContainer">
            <p className="profil">
              {props.userInfo!.name ||
                get(props.userInfo!, 'preferred_username')}
            </p>
            <Link className="logOutBtn" onClick={props.logout}>
              {translate({ ...messages.appBarDisconnectTitle }, props)}
            </Link>
          </span>
        </Toolbar>
      </AppBar>
      {isDrawerOpen && featureService.hasFeature(FEATURES.NOTIFICATION) && (
        <SahamDrawer
          open={isDrawerOpen}
          handleToggleDrawer={handleToggleDrawer}
          title={translate({ ...messages.sideBarNotificationTitle }, props)}
          isDisplayCancelButton={false}
          isDisplayCloseButton={true}
          handleScroll={handleScroll as any}
        >
          {utils.isManager(props) ? (
            isEmpty(managerNotifications) &&
            isEmpty(openingManagerNotificationsMixedClaim) ? (
              <NotificationEmptyBloc />
            ) : isManagerOpeningManager ? (
              <>
                {[
                  ...openingManagerNotificationsMixedClaim.filter(
                    el =>
                      el.status === PROCEDURE_STATUSES.PENDING &&
                      isNil(el.managerNotificationTypeId),
                  ),
                  ...managerNotifications
                    .filter(
                      el =>
                        ((!isEmpty(el.notificationManagerMapping) &&
                          !isEmpty(
                            el.notificationManagerMapping?.filter(
                              (item: any) =>
                                get(item, 'userPrivilegesId') ===
                                get(currentUserStorage.get().privileges, 'id'),
                            ),
                          )) ||
                          (el.binManagerId === BIN_MANAGER_OPENING_MANAGER &&
                            isEmpty(el.notificationManagerMapping)) ||
                          OpeningTypeNotifications.includes(
                            el?.managerNotificationTypeId,
                          )) &&
                        el.readBy === null,
                    )
                    .map((el: any) => ({
                      ...el,
                      createdAt: el.created_at,
                    })),
                ]
                  .sort(
                    (a, b) =>
                      new Date(get(b, 'createdAt')).valueOf() -
                      new Date(get(a, 'createdAt')).valueOf(),
                  )
                  .map((el: any) => (
                    <div
                      style={{
                        marginLeft: '5px',
                        marginRight: '3px',
                        cursor: 'pointer',
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        onClick={() => {
                          if (
                            OpeningTypeNotifications.includes(
                              el?.managerNotificationTypeId,
                            )
                          ) {
                            props.setNotification(el);
                          } else if (isInboxeTitle(get(el, 'title'))) {
                            props.requestRefreshManager(
                              props.successCallBackRefresh,
                            );
                            requestReadManagerNotification({
                              id: get(el, 'id'),
                              isTransaction: !isNil(
                                get(el, 'transactionInboxeAreaId', null),
                              ),
                            });
                            setIsNotificationDialogOpen(false);
                            setIsDrawerOpen(false);
                            setIsDrawerInboxesOpen(false);
                          } else {
                            if (
                              (!isEmpty(el?.notificationManagerMapping) &&
                                !isEmpty(
                                  el?.notificationManagerMapping?.filter(
                                    (item: any) =>
                                      get(item, 'userPrivilegesId') ===
                                      get(
                                        currentUserStorage.get().privileges,
                                        'id',
                                      ),
                                  ),
                                )) ||
                              (isEmpty(get(el, 'notificationManagerMapping')) &&
                                get(el, 'binManagerId') ===
                                  BIN_MANAGER_OPENING_MANAGER)
                            ) {
                              setCurrentClaimId(el.claimId);
                              setCurrentNotificationId(el.id);
                              setCurrentNotification(el);
                              setIsNotificationDialogOpen(true);
                            } else {
                              history.push(PAGES.CONVERT_CLAIM_MANAGER_PAGE);
                              props.setClaimNumber(get(el, 'claimNumber', ''));
                              props.setSelectedClaim(0);
                              props.setNotification(el);
                              setIsDrawerOpen(false);
                            }
                          }
                        }}
                      >
                        <StyledGrid item xs={8}>
                          {el.title}
                        </StyledGrid>
                        <StyledGrid item xs={4}>
                          <TimeAgo datetime={el.createdAt} locale="fr" />
                        </StyledGrid>
                      </Grid>
                    </div>
                  ))}
              </>
            ) : isMonitoringCourtManager ? (
              <>
                {managerNotifications
                  .filter(
                    el =>
                      (el.binManagerId === BIN_MOUNITORING_COURT_MANAGER ||
                        (!isEmpty(el.notificationManagerMapping) &&
                          !isEmpty(
                            el.notificationManagerMapping?.filter(
                              (item: any) =>
                                get(item, 'userPrivilegesId') ===
                                get(currentUserStorage.get().privileges, 'id'),
                            ),
                          ))) &&
                      el.readBy === null &&
                      el.managerNotificationTypeId === null,
                  )
                  .sort(
                    (a, b) =>
                      new Date(b.created_at).valueOf() -
                      new Date(a.created_at).valueOf(),
                  )
                  .map((el: any) => (
                    <div
                      style={{
                        marginLeft: '5px',
                        marginRight: '3px',
                        cursor: 'pointer',
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        onClick={() => {
                          if (isInboxeTitle(get(el, 'title'))) {
                            props.requestRefreshManager(
                              props.successCallBackRefresh,
                            );
                            requestReadManagerNotification({
                              id: get(el, 'id'),
                              isTransaction: !isNil(
                                get(el, 'transactionInboxeAreaId', null),
                              ),
                            });
                            setIsDrawerOpen(false);
                            setIsDrawerInboxesOpen(false);
                          } else {
                            setIsNotificationDialogOpen(true);
                            setCurrentNotificationId(el.id);
                            setCurrentClaimId(el.claimId);
                            setCurrentNotification(el);
                          }
                        }}
                      >
                        {isRejectionTitle(el.title) ? (
                          <AlertNotification
                            title={el.title}
                            created_at={el.created_at}
                          />
                        ) : (
                          <StyledGrid item xs={8}>
                            {el.title}
                          </StyledGrid>
                        )}
                        {isRejectionTitle(el.title) ? (
                          <></>
                        ) : (
                          <StyledGrid item xs={4}>
                            <TimeAgo datetime={el.created_at} locale="fr" />
                          </StyledGrid>
                        )}
                      </Grid>
                    </div>
                  ))}
              </>
            ) : isManagerCourtMonitoringManager ? (
              <>
                {managerNotifications
                  .filter(
                    el =>
                      (el.binManagerId === BIN_MOUNITORING_COURT_MANAGER ||
                        (!isEmpty(el.notificationManagerMapping) &&
                          !isEmpty(
                            el.notificationManagerMapping?.filter(
                              (item: any) =>
                                get(item, 'userPrivilegesId') ===
                                get(currentUserStorage.get().privileges, 'id'),
                            ),
                          ))) &&
                      el.readBy === null &&
                      el.managerNotificationTypeId === null,
                  )
                  .sort(
                    (a, b) =>
                      new Date(b.created_at).valueOf() -
                      new Date(a.created_at).valueOf(),
                  )
                  .map((el: any) => (
                    <div
                      style={{
                        marginLeft: '5px',
                        marginRight: '3px',
                        cursor: 'pointer',
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        onClick={() => {
                          if (isInboxeTitle(get(el, 'title'))) {
                            props.requestRefreshManager(
                              props.successCallBackRefresh,
                            );
                            requestReadManagerNotification({
                              id: get(el, 'id'),
                              isTransaction: !isNil(
                                get(el, 'transactionInboxeAreaId', null),
                              ),
                            });
                            setIsDrawerOpen(false);
                            setIsDrawerInboxesOpen(false);
                          } else {
                            setIsNotificationDialogOpen(true);
                            setCurrentNotificationId(el.id);
                            setCurrentClaimId(el.claimId);
                            setCurrentNotification(el);
                          }
                        }}
                      >
                        {isRejectionTitle(el.title) ? (
                          <AlertNotification
                            title={el.title}
                            created_at={el.created_at}
                          />
                        ) : (
                          <StyledGrid item xs={8}>
                            {el.title}
                          </StyledGrid>
                        )}
                        {isRejectionTitle(el.title) ? (
                          <></>
                        ) : (
                          <StyledGrid item xs={4}>
                            <TimeAgo datetime={el.created_at} locale="fr" />
                          </StyledGrid>
                        )}
                      </Grid>
                    </div>
                  ))}
              </>
            ) : isOpeningManager() ? (
              isEmpty(openingManagerNotificationsMixedClaim) ? (
                <NotificationEmptyBloc />
              ) : (
                <>
                  {[
                    ...openingManagerNotificationsMixedClaim.filter(
                      el =>
                        el.status === PROCEDURE_STATUSES.PENDING &&
                        isNil(el?.managerNotificationTypeId),
                    ),
                    ...managerNotifications
                      .filter(
                        el =>
                          ((!isEmpty(el.notificationManagerMapping) &&
                            !isEmpty(
                              el.notificationManagerMapping?.filter(
                                (item: any) =>
                                  get(item, 'userPrivilegesId') ===
                                  get(
                                    currentUserStorage.get().privileges,
                                    'id',
                                  ),
                              ),
                            )) ||
                            OpeningTypeNotifications.includes(
                              el?.managerNotificationTypeId,
                            )) &&
                          el.readBy === null,
                      )
                      .map((el: any) => ({
                        ...el,
                        createdAt: el.created_at,
                      })),
                  ]
                    .sort(
                      (a, b) =>
                        new Date(get(b, 'createdAt')).valueOf() -
                        new Date(get(a, 'createdAt')).valueOf(),
                    )
                    .map((el: any) => (
                      <div
                        style={{
                          marginLeft: '5px',
                          marginRight: '3px',
                          cursor: 'pointer',
                        }}
                      >
                        <Grid
                          container
                          direction="row"
                          onClick={() => {
                            if (
                              OpeningTypeNotifications.includes(
                                el?.managerNotificationTypeId,
                              )
                            ) {
                              props.setNotification(el);
                            } else if (isInboxeTitle(get(el, 'title'))) {
                              props.requestRefreshManager(
                                props.successCallBackRefresh,
                              );
                              requestReadManagerNotification({
                                id: get(el, 'id'),
                                isTransaction: !isNil(
                                  get(el, 'transactionInboxeAreaId', null),
                                ),
                              });
                              setIsDrawerOpen(false);
                              setIsDrawerInboxesOpen(false);
                            } else {
                              if (
                                !isEmpty(el.notificationManagerMapping) &&
                                !isEmpty(
                                  el.notificationManagerMapping?.filter(
                                    (item: any) =>
                                      get(item, 'userPrivilegesId') ===
                                      get(
                                        currentUserStorage.get().privileges,
                                        'id',
                                      ),
                                  ),
                                )
                              ) {
                                setCurrentClaimId(el.claimId);
                                setCurrentNotificationId(el.id);
                                setCurrentNotification(el);
                                setIsNotificationDialogOpen(true);
                              } else {
                                history.push(PAGES.CONVERT_CLAIM_MANAGER_PAGE);
                                props.setClaimNumber(
                                  get(el, 'claimNumber', ''),
                                );
                                props.setSelectedClaim(0);
                                props.setNotification(el);
                                setIsDrawerOpen(false);
                              }
                            }
                          }}
                        >
                          <StyledGrid item xs={8}>
                            {el.title}
                          </StyledGrid>
                          <StyledGrid item xs={4}>
                            <TimeAgo datetime={el.createdAt} locale="fr" />
                          </StyledGrid>
                        </Grid>
                      </div>
                    ))}
                </>
              )
            ) : (
              <BinDiv>
                {managerNotifications
                  .filter(
                    el =>
                      ((el.assignedManagerCode === assignedManagerCode &&
                        isEmpty(el.notificationManagerMapping)) ||
                        (!isEmpty(el.notificationManagerMapping) &&
                          !isEmpty(
                            el.notificationManagerMapping?.filter(
                              (item: any) =>
                                get(item, 'userPrivilegesId') ===
                                get(currentUserStorage.get().privileges, 'id'),
                            ),
                          ))) &&
                      el.readBy === null &&
                      (el.managerNotificationTypeId === null ||
                        el.transactionInboxeAreaId === null),
                  )
                  .sort(
                    (a, b) =>
                      new Date(b.created_at).valueOf() -
                      new Date(a.created_at).valueOf(),
                  )
                  .map((el: any) => (
                    <div
                      style={{
                        marginLeft: '5px',
                        marginRight: '3px',
                        cursor: 'pointer',
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        onClick={() => {
                          if (isInboxeTitle(get(el, 'title'))) {
                            props.requestRefreshManager(
                              props.successCallBackRefresh,
                            );
                            requestReadManagerNotification({
                              id: get(el, 'id'),
                              isTransaction: !isNil(
                                get(el, 'transactionInboxeAreaId', null),
                              ),
                            });
                            setIsDrawerOpen(false);
                            setIsDrawerInboxesOpen(false);
                          } else {
                            setCurrentNotificationId(el.id);
                            setCurrentClaimId(el.claimId);
                            setIsNotificationDialogOpen(true);
                            setCurrentNotification(el);
                          }
                        }}
                      >
                        <StyledGrid item xs={8}>
                          {el.title}
                        </StyledGrid>
                        <StyledGrid item xs={4}>
                          <TimeAgo datetime={el.created_at} locale="fr" />
                        </StyledGrid>
                      </Grid>
                    </div>
                  ))}
                {get(props.loaders, 'NOTIFICATION') && <CircularProgress />}
              </BinDiv>
            )
          ) : utils.isExpert(props) ? (
            isEmpty(expertNotifications) ? (
              <NotificationEmptyBloc />
            ) : (
              <>
                {expertNotifications
                  .filter(el => el.readBy === null)
                  .sort(
                    (a, b) =>
                      new Date(b.created_at).valueOf() -
                      new Date(a.created_at).valueOf(),
                  )
                  .map((el: any) => (
                    <div
                      style={{
                        marginLeft: '5px',
                        marginRight: '3px',
                        cursor: 'pointer',
                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        onClick={() => {
                          setCurrentExpertNotification(el);
                          setIsNotificationDialogOpen(true);
                        }}
                      >
                        <StyledGrid item xs={8}>
                          {el.title}
                        </StyledGrid>
                        <StyledGrid item xs={4}>
                          <TimeAgo datetime={el.created_at} locale="fr" />
                        </StyledGrid>
                      </Grid>
                    </div>
                  ))}
              </>
            )
          ) : isEmpty(lawyerNotifications) ? (
            <NotificationEmptyBloc />
          ) : (
            <>
              {lawyerBins[0] && (
                <Bin
                  title={lawyerBins[0]?.title}
                  count={resolveCount(
                    lawyerNotifications.filter(
                      (el: any) =>
                        el.readBy === null &&
                        el.lawyerCode ===
                          currentIntervenantStorage.get()?.sagis_code,
                    ),
                    lawyerBins[0].id,
                  )}
                  index={0}
                  expandRow={expandRow}
                  setExpandRow={setExpandRow}
                  lawyerNotifications={lawyerNotifications}
                  setIsNotificationDialogOpen={setIsNotificationDialogOpen}
                  id={lawyerBins[0]?.id}
                  currentClaimId={currentClaimId}
                  setCurrentClaimId={setCurrentClaimId}
                  setCurrentNotificationId={setCurrentNotificationId}
                />
              )}
              {invoiceLawyerBin && (
                <Bin
                  title={invoiceLawyerBin?.title}
                  count={resolveCount(
                    lawyerNotifications.filter(
                      (el: any) =>
                        el.readBy === null &&
                        el.lawyerCode ===
                          currentIntervenantStorage.get()?.sagis_code,
                    ),
                    invoiceLawyerBin?.id,
                  )}
                  index={1}
                  expandRow={expandRow}
                  setExpandRow={setExpandRow}
                  lawyerNotifications={lawyerNotifications}
                  setIsNotificationDialogOpen={setIsNotificationDialogOpen}
                  id={invoiceLawyerBin?.id}
                  currentClaimId={currentClaimId}
                  setCurrentClaimId={setCurrentClaimId}
                  setCurrentNotificationId={setCurrentNotificationId}
                />
              )}
              {sortedProcedures.map(procedure => (
                <BinsWrapper title={procedure?.title}>
                  <BinDiv>
                    {lawyerBins.map(
                      (
                        element: {
                          title: string;
                          id: number;
                        },
                        index: number,
                      ) =>
                        element.id !== 1 &&
                        element.id !== get(invoiceLawyerBin, 'id') && (
                          <Bin
                            title={element.title}
                            count={resolveCount(
                              lawyerNotifications.filter(
                                (el: any) =>
                                  el.readBy === null &&
                                  el.lawyerCode ===
                                    currentIntervenantStorage.get()
                                      ?.sagis_code &&
                                  el.judiciaryProcessBinId === procedure?.id,
                              ),
                              element.id,
                            )}
                            index={index}
                            expandRow={expandRow}
                            setExpandRow={setExpandRow}
                            lawyerNotifications={lawyerNotifications}
                            setIsNotificationDialogOpen={
                              setIsNotificationDialogOpen
                            }
                            id={element.id}
                            currentClaimId={currentClaimId}
                            setCurrentClaimId={setCurrentClaimId}
                            setCurrentNotificationId={setCurrentNotificationId}
                            procedureId={procedure?.id}
                            key={element.id}
                          />
                        ),
                    )}
                  </BinDiv>
                </BinsWrapper>
              ))}
            </>
          )}
        </SahamDrawer>
      )}
      {isNotificationDialogOpen &&
        featureService.hasFeature(FEATURES.NOTIFICATION) && (
          <Dialog
            open={isNotificationDialogOpen}
            handleClose={handleCloseNotificationDialog}
            handleValidate={handleValidate}
            title={translate(messages.sideBarNotificationDialogTitle, props)}
            confirmTitle={translate(
              messages.sideBarNotificationDialogConfirm,
              props,
            )}
            cancelTitle={translate(
              messages.sideBarNotificationDialogCancel,
              props,
            )}
          >
            <div className="content">
              {renderTitleConfirmationDialog(
                lawyerNotifications,
                messages,
                props,
                currentNotification,
              )}
            </div>
            <div className="info-message">
              {renderSubTitleConfirmationDialog(
                lawyerNotifications,
                messages,
                props,
                currentNotification,
              )}
            </div>
          </Dialog>
        )}
      <InboxesDrawer
        isDrawerOpen={isDrawerInboxesOpen}
        setIsDrawerOpen={setIsDrawerInboxesOpen}
        listings={props.listings}
        expandRow={expandRowInboxe}
        setExpandRow={setExpandRoweInboxe}
        managerNotifications={notificationsInboxes}
        handleClickNotificationInboxe={handleClickNotificationInboxe}
        openingManagerNotificationsMixedClaim={
          openingManagerNotificationsMixedClaim
        }
        requestGetNotificationsInboxes={props.requestGetNotificationsInboxes}
        loaders={props.loaders}
      />
      <LaywerInboxesDrawer
        isDrawerOpen={isDrawerLawyerInboxesOpen}
        setIsDrawerOpen={setIsDrawerLaywerInboxesOpen}
        listings={props.listings}
        expandRow={expandRowInboxe}
        setExpandRow={setExpandRoweInboxe}
        loaders={props.loaders}
        inboxesLawyerNotifications={inboxesLawyerNotifications}
        requestGetInboxesLawyerNotifications={
          requestGetInboxesLawyerNotifications
        }
        handleClickNotificationInboxe={handleClickNotificationInboxe}
      />
    </AppBarDiv>
  );
};

AppBarContainer.defaultProps = {
  showStepper: false,
};

export default injectIntl(AppBarContainer);
